import { useState } from 'react';
import { Link } from 'react-router';

import Card from '@mui/material/Card';
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from '@mui/material/CardMedia';

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton';

import Typescript from '@mui/material/Typography'

import Title from '../../components/Title'
import Text from '../../components/Text'

import icon_1 from '../../images/image.png'

import image from '../../images/symptoms/confronto.png'


export default function CardItem({ item }) {

  return (
    <>

      <Card key={item.id} className="card">

        <Link underline="none" to={"/essay#" + item.id}>

          <Grid container flexDirection="row" alignItems="center" spacing={2} className="px-2">

            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <CardMedia
                component="img"
                image={"news/"+item.id+"/"+item.image}
                width={1}
                height={2}
                className="cardimage"
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 8 }}>
              <CardContent>
                <Title variant="card" size="22pt" text={item.title} color="orange" />
                <Text variant="bolditalic" text={item.intro} color="green" />
              </CardContent>
            </Grid>

          </Grid>

        </Link>

      </Card>

    </>
  );
}
